import { atom } from 'recoil';
import { SessionPresentation } from '~/backend/connector-api/connector-schemas';

export const sessionDataAtom = atom<SessionPresentation | undefined>({
    key: 'sessionDataAtom',
    default: undefined,
});

export interface SessionInitStatus {
    isLoading: boolean;
    hasStarted: boolean;
    error: Error | null;
}

export const sessionInitStatusAtom = atom<SessionInitStatus>({
    key: 'sessionInitStatusAtom',
    default: { isLoading: false, hasStarted: false, error: null },
});
